import script from "./order-gradient.vue?vue&type=script&setup=true&lang=ts"
export * from "./order-gradient.vue?vue&type=script&setup=true&lang=ts"

import "./order-gradient.vue?vue&type=style&index=0&id=47ca570c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ca570c"]])

export default __exports__